import { render, staticRenderFns } from "./ProductList.component.pug?vue&type=template&id=6ac18b5e&scoped=true&lang=pug&"
import script from "./ProductList.component.ts?vue&type=script&lang=ts&"
export * from "./ProductList.component.ts?vue&type=script&lang=ts&"
import style0 from "./ProductList.component.scss?vue&type=style&index=0&id=6ac18b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac18b5e",
  null
  
)

export default component.exports